// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"994bfb31","280":"d1609db9","287":"bda4e84e","641":"af16ebfa","756":"1abf2563","791":"51120be3","859":"1889503a","923":"afeb2250","932":"737b78f5"}[chunkId] + ".chunk.js";
};